<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article class="post-30 page type-page status-publish hentry">
          <div class="entry-content">
            <!-- PHASE 1 -->
            <div class="slider-moving hc-choose-domain-name">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="parent-typed-text wow fadeIn">
                      <span class="mt_typed-beforetext">We take care of</span>
                      <span class="mt_typed_text mt_typed_text_5b48675d69375"
                        >your content</span
                      >
                      <span class="mt_typed-aftertext"></span>
                    </div>
                    <p class="wow fadeIn">
                      The Leading Company available for removing all affected
                      contents from the entire cyber space.
                    </p>
                    <div class="spacer_50"></div>
                    <div class="wow fadeIn text-center">
                      <a class="hc-btn-green" href="pricing" title
                        >GET STARTED</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <!-- PHASE 2 -->
            <div
              class="hc-hosting-solution row"
              style="height: 100%; position: relative; margin: -15px 0px; padding: 0"
            >
              <div class="col-sm-12">
                <!-- <div class="video-container">
                  <div class="bg-1"></div>
                  <div class="bg-2"></div>
                </div> -->
                <section class="video-section">
                  <div class="container">
                    <div class="video-img">
                      <a
                        data-fancybox="gallery"
                        href="https://staging.clearmeout.com/intro.mp4"
                      >
                        <img src="/static/assets/images/video_image.png" />
                        <div class="video-icon">
                          <i class="fa fa-play v-play-btn"></i>
                        </div>
                      </a>
                    </div>
                  </div>
                </section>
                <!-- <div class="vimeo-wrapper-test">
                  <iframe
                    src="https://player.vimeo.com/video/76979871?background=0&autoplay=0&loop=0&byline=0&title=0"
                    frameborder="0"
                  ></iframe>
                </div> -->
              </div>
            </div>
            <div class="clearfix"></div>

            <!-- PHASE 3 -->
            <div class="hc-hosting-solution row">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn">
                  <h1 class="section-title dark_title">
                    Cyber Problems are Severe
                  </h1>
                  <div class="section-subtitle dark_subtitle">
                    Individuals are harassed, defamed. Intellectual property,
                    copyrights, contents of business are faked or stolen.
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-hosting-solution-cont">
              <div class="container">
                <div class="row">
                  <div class="col-sm-4 hc-hosting-solution-web">
                    <div class="hc-hosting-solution-web-cont">
                      <div
                        class="wpb_single_image wpb_content_element text-center wow fadeIn"
                      >
                        <figure>
                          <div>
                            <img
                              src="/static/assets/images/personal.png"
                              class="attachment-medium"
                              alt
                            />
                          </div>
                        </figure>
                      </div>
                      <h1 class="wow fadeIn">Personal</h1>
                      <div class="wow fadeIn">
                        <p>
                          Cyber bullying, harassing
                          <br />and stalking could make <br />your life unhappy.
                        </p>
                      </div>
                      <div
                        class="hc-btn-read-more text-center modeltheme_button wow fadeIn"
                      >
                        <a
                          href="/personal-cyber-harassments"
                          class="button-winona btn btn-medium btn_custom_5b48675d6d087"
                          style="width: min-content; text-align: center"
                          >Read more</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4 hc-hosting-solution-web">
                    <div class="hc-hosting-solution-web-cont">
                      <div
                        class="wpb_single_image wpb_content_element text-center wow fadeIn"
                      >
                        <figure>
                          <div>
                            <img
                              src="/static/assets/images/celebrity_vip.png"
                              class="attachment-medium"
                              alt
                            />
                          </div>
                        </figure>
                      </div>
                      <h1 class="wow fadeIn">Celebrity and VIP</h1>
                      <div class="wow fadeIn">
                        <p>
                          Lost reputation / privacy,
                          <br />defamation could be <br />your major obstacle.
                        </p>
                      </div>
                      <div
                        class="hc-btn-read-more text-center modeltheme_button wow fadeIn"
                      >
                        <a
                          href="/celebrity-vip"
                          class="button-winona btn btn-medium btn_custom_5b48675d6d087"
                          style="width: min-content; text-align: center"
                          >Read more</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4 hc-hosting-solution-web">
                    <div class="hc-hosting-solution-web-cont">
                      <div
                        class="wpb_single_image wpb_content_element text-center wow fadeIn"
                      >
                        <figure>
                          <div>
                            <img
                              src="/static/assets/images/business.png"
                              class="attachment-medium"
                              alt
                            />
                          </div>
                        </figure>
                      </div>
                      <h1 class="wow fadeIn">Business</h1>
                      <div class="wow fadeIn">
                        <p>
                          False reviews, Impersonation
                          <br />or stolen IP could <br />bring any business
                          down.
                        </p>
                      </div>
                      <div
                        class="hc-btn-read-more text-center modeltheme_button wow fadeIn"
                      >
                        <a
                          href="/Internet-business-issues"
                          class="button-winona btn btn-medium btn_custom_5b48675d6d087"
                          style="width: min-content; text-align: center"
                          >Read more</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--PHASE 4-->
            <div class="clearfix"></div>
            <div class="hc-home-vpn-setup">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <h1 class="wow fadeIn hc-h1">Protect</h1>
                    <div class="wow fadeIn">
                      <p class="hc-p">
                        We protect your / your businesses’ reputation / image
                        through
                        <br />removing all stolen, negative, unethical, false,
                        fake contents about <br />you or your business in the
                        internet and avoid their reappearance by
                        <br />continuously monitoring the process.
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="wow fadeIn">
                      <img
                        class="aligncenter size-medium"
                        src="/static/assets/images/protect.png"
                        alt="hostcluster_bank_setup-1"
                        style="max-width: 350px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Save Money and Time -->
            <div class="clearfix"></div>
            <div class="hc-home-vpn-conf">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="wow fadeIn">
                      <img
                        class="aligncenter size-medium wp-image-2116"
                        src="/static/assets/images/save_money_and_time.png"
                        alt="hostcluster_bank_secure"
                        style="max-width: 350px"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <h1 class="wow fadeIn hc-h1">Save Money and Time</h1>
                    <div class="wow fadeIn">
                      <p class="hc-p">
                        Since our system is based on an AI technology we
                        complete
                        <br />all our internal processes instantly and
                        accurately, and provide <br />you a quick better service
                        at an affordable fees.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- High Confidentiality -->
            <div class="clearfix"></div>
            <div class="hc-home-vpn-customer">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <h1 class="wow fadeIn hc-h1">High Confidentiality</h1>
                    <div class="wow fadeIn">
                      <p class="hc-p">
                        Since our most widely used general service on removing
                        <br />contents is fully automated with very minimum if
                        not <br />non-involvement of people, the confidentiality
                        of customer <br />information is maintained at an
                        exceptionally high level.
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="wow fadeIn">
                      <img
                        class="aligncenter size-medium"
                        src="/static/assets/images/high_confidentiality.png"
                        alt="hostcluster_bank_customers"
                        style="max-width: 350px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PHASE 5 -->
            <div class="clearfix"></div>
            <div class="hc-included-price row" style="background: #7681e0">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn" style>
                  <h1 class="section-title dark_title" style="color: #fff">
                    Image Packages
                  </h1>
                  <div
                    class="section-subtitle dark_subtitle"
                    style="color: #fff"
                  >
                    All of your personal images are removed
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-included-price-cont horizontal-pricing-tables">
              <div class="container">
                <div class="row">
                  <div class="list-configurations col-sm-3">
                    <h1 class="wow fadeIn">Our Plans</h1>
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--business">
                            <div class="pricing__price">
                              <span class="pricing__currency"></span>
                            </div>
                            <p class="package__per__feature"></p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                Images
                                <span class="tooltiptext"
                                  >Total number of images removed</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Days
                                <span class="tooltiptext"
                                  >Actual number of days taken for image
                                  removal</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Detailed Report
                                <span class="tooltiptext"
                                  >Details of the service provided on image
                                  removal</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                48 Hours
                                <span class="tooltiptext"
                                  >Remove your images within 48 hours</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Offenders Location
                                <span class="tooltiptext"
                                  >Detects and reveals the first location or
                                  multiple locations where offender was
                                  operating</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Removal Limit
                                <span class="tooltiptext"
                                  >We remove your images from any number of
                                  locations</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Counseling Psychologist
                                <span class="tooltiptext"
                                  >Counselling helps you to get relief from the
                                  stress created by harassment</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Additional Images
                                <span class="tooltiptext"
                                  >Additional images can be included for
                                  removal</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Initial Setup Fee
                                <span class="tooltiptext"
                                  >No initial setup fee is charged for this
                                  service</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Customer Support
                                <span class="tooltiptext"
                                  >You will be provided with 24x7 dedicated
                                  support service.</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Basic</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>499
                            </div>
                            <p class="package__per__feature">starting from</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature">
                                3
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                21
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Included
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Standard</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>999
                            </div>
                            <p class="package__per__feature">starting from</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature">
                                6
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                14
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Included
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-red col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--premium">
                            <div class="package__recommended">Premium</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>1599
                            </div>
                            <p class="package__per__feature">starting from</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature">
                                10
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                7
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Included
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                24/7
                                <i class="fa fa-check-circle"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
            <div class="hc-included-price row" style="background: #7681e0">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn" style>
                  <h1 class="section-title dark_title" style="color: #fff">
                    Video Packages
                  </h1>
                  <div
                    class="section-subtitle dark_subtitle"
                    style="color: #fff"
                  >
                    All of your personal videos are removed
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
            <div class="hc-included-price-cont horizontal-pricing-tables">
              <div class="container">
                <div class="row">
                  <div class="list-configurations col-sm-3">
                    <h1 class="wow fadeIn">Our Plans</h1>
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--business">
                            <div class="pricing__price">
                              <span class="pricing__currency"></span>
                            </div>
                            <p class="package__per__feature"></p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                Videos
                                <span class="tooltiptext"
                                  >Total number of videos removed</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Days
                                <span class="tooltiptext"
                                  >Actual number of days taken for video
                                  removal</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Detailed Report
                                <span class="tooltiptext"
                                  >Details of the service provided on video
                                  removal</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                48 Hours
                                <span class="tooltiptext"
                                  >Remove your video within 48 hours</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Offenders Location
                                <span class="tooltiptext"
                                  >Detects and reveals the first location or
                                  multiple locations where offender was
                                  operating</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Removal Limit
                                <span class="tooltiptext"
                                  >We remove your video from any number of
                                  locations</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Counseling Psychologist
                                <span class="tooltiptext"
                                  >Counselling helps you to get relief from the
                                  stress created by harassment</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Additional Videos
                                <span class="tooltiptext"
                                  >Additional videos can be included for
                                  removal</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Initial Setup Fee
                                <span class="tooltiptext"
                                  >No initial setup fee is charged for this
                                  service</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Customer Support
                                <span class="tooltiptext"
                                  >You will be provided with 24x7 dedicated
                                  support service.</span
                                >
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Basic</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>599
                            </div>
                            <p class="package__per__feature">starting from</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature">
                                1
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                21
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Included
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Standard</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>1299
                            </div>
                            <p class="package__per__feature">starting from</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature">
                                3
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                14
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Included
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-red col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--premium">
                            <div class="package__recommended">Premium</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>2699
                            </div>
                            <p class="package__per__feature">starting from</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature">
                                7
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                7
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Included
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Optional
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature">
                                24/7
                                <i class="fa fa-check-circle"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="/pricing"
                              >Choose now</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PHASE 6 -->
            <div class="clearfix"></div>
            <div class="hc-start-web">
              <div class="container">
                <div class="row">
                  <div class="col-sm-8">
                    <h2 class="wow fadeIn" style="color: white">
                      Look for removing Audios or Texts?
                    </h2>
                  </div>
                  <div class="col-sm-4">
                    <div class="spacer_7"></div>
                    <div class="clearfix"></div>
                    <div class="hc-btn-read-more-bk-red wow fadeIn">
                      <a href="/personal" title>GET STARTED</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PHASE 7 -->
            <div class="clearfix"></div>
            <div class="hc-home-vpn-guarantee">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <h1 class="wow fadeIn hc-h1">Business Services</h1>
                    <div class="wow fadeIn margin-top-bottom-30">
                      <p class="hc-p">
                        By removing online false / fake reviews and contents,
                        and protecting IP / reputation of a business its image
                        and outlook in the internet are improved greatly in
                        addition to saving money by many folds. The image /
                        reputation of Celebrities and VIPs are too protected
                        through content removal. The Service initiates with
                        monitoring and removal of contents and assures business
                        security by stopping their re-appearance totally,
                        through process continuation.
                      </p>
                    </div>
                    <div class="spacer_10"></div>
                    <div class="wow fadeIn text-left">
                      <a href="/business" title>GET STARTED</a>
                    </div>
                  </div>
                  <div class="text-center col-sm-12 col-md-6">
                    <div class="wow fadeIn">
                      <img
                        class="aligncenter size-medium"
                        src="/static/assets/images/business_services.png"
                        alt="hostcluster_bank_icon"
                        style="max-width: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PHASE 8 -->
            <div class="clearfix"></div>
            <div class="hc-your-opinion row">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn">
                  <h1 class="section-title light_title">
                    WE CARE ABOUT YOUR OPINION
                  </h1>
                  <div class="section-subtitle light_subtitle">
                    They're happy about doing business with us
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-your-opinion-cont">
              <div class="container">
                <div class="row">
                  <div
                    class="wow fadeIn testimonials-container-2 owl-carousel owl-theme"
                  >
                    <div class="owl-item">
                      <div class="item col-md-12 relative">
                        <div class="testimonial01_item">
                          <div class="testimonial01-img-holder pull-left">
                            <h2 class="name-test">
                              <strong>Anonymous</strong>
                            </h2>
                            <p class="position-test">Personal Service</p>
                            <div class="testimonail01-content">
                              <p>
                                I am very much thankful to you for making my
                                life happier and now I am enjoying my life with
                                my family very peacefully. At one stage I was
                                totally upset and thought of moving away from my
                                house as I felt very inconvenient to face my
                                parents. You are very quick in removing my
                                stolen pictures appeared in the internet. If you
                                wish you may publish this message but please
                                don’t disclose my identity.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="owl-item">
                      <div class="item col-md-12 relative">
                        <div class="testimonial01_item">
                          <div class="testimonial01-img-holder pull-left">
                            <h2 class="name-test">
                              <strong>Anonymous</strong>
                            </h2>
                            <p class="position-test">Business Service</p>
                            <div class="testimonail01-content">
                              <p>
                                The unreasonable faked reviews was a major issue
                                of our company for the last few years. Our
                                business reputation was badly damaged and we
                                were compelled to reengineer our business with
                                bringing in new strategies for protecting our
                                brand image and company reputation. Your service
                                was remarkable and we are looking forward to
                                obtain the service of continued content removal
                                and monitoring.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="owl-item">
                      <div class="item col-md-12 relative">
                        <div class="testimonial01_item">
                          <div class="testimonial01-img-holder pull-left">
                            <h2 class="name-test">
                              <strong>Anonymous</strong>
                            </h2>
                            <p class="position-test">Personal Service</p>
                            <div class="testimonail01-content">
                              <p>
                                As you promised you did your service excellently
                                by removing the stolen and faked photos of my
                                daughter in the internet. Definitely I will
                                recommend your service to anyone who faces this
                                kind of problem. I remain with thanks and
                                regards.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PHASE 9 -->
            <div class="clearfix"></div>
            <div class="hc-faq row">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn">
                  <h1 class="section-title dark_title">
                    FREQUENTLY ASKED QUESTIONS
                  </h1>
                  <div class="section-subtitle dark_subtitle">
                    We're here to help. Get in touch and we'll get back to you
                    as soon as we can
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-faq-content">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="hc-faq-content-row">
                      <div class="row">
                        <div
                          class="hc-faq-cont collum-shadow column-hoverv1 col-sm-6"
                        >
                          <div class="hc-faq-cont-col">
                            <h1 class="wow fadeIn">
                              How can I start this process?
                            </h1>
                            <div class="wow fadeIn">
                              <p>
                                Just sign up if you need to remove your images
                                and
                                <br />videos and if it is text or audio related,
                                please contact <br />us via email
                                <a href="mailto:service@clearmeout.com"
                                  >service@clearmeout.com</a
                                >.
                              </p>
                            </div>
                            <div class="hc-btn-read-more-red wow fadeIn">
                              <a href="/faq" title>
                                Read more
                                <i class="fa fa-long-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          class="hc-faq-cont collum-shadow column-hoverv1 col-sm-6"
                        >
                          <div class="hc-faq-cont-col">
                            <h1 class="wow fadeIn">
                              Are there any hidden charges?
                            </h1>
                            <div class="wow fadeIn">
                              <p>
                                No. We do not have any hidden charges and
                                <br />we charge only your service payment and
                                <br />the credit card fee (3.5%)
                              </p>
                            </div>
                            <div class="hc-btn-read-more-red wow fadeIn">
                              <a href="/faq" title>
                                Read more
                                <i class="fa fa-long-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="hc-faq-cont collum-shadow column-hoverv1 col-sm-6"
                        >
                          <div class="hc-faq-cont-col">
                            <h1 class="wow fadeIn">
                              Is it possible to track the person
                              <br />who leaked the contents?
                            </h1>
                            <div class="wow fadeIn">
                              <p>
                                Yes you can. Using the feature of identifying
                                <br />the location of offender, we track down
                                the <br />offender.
                              </p>
                            </div>
                            <div class="hc-btn-read-more-red wow fadeIn">
                              <a href="/faq" title>
                                Read more
                                <i class="fa fa-long-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          class="hc-faq-cont collum-shadow column-hoverv1 col-sm-6"
                        >
                          <div class="hc-faq-cont-col">
                            <h1 class="wow fadeIn">
                              What personal information
                              <br />needed for the process?
                            </h1>
                            <div class="wow fadeIn">
                              <p>
                                Your name, address, phone number, email
                                <br />address and a copy of your national
                                <br />identity card or passport.
                              </p>
                            </div>
                            <div class="hc-btn-read-more-red wow fadeIn">
                              <a href="/faq" title>
                                Read more
                                <i class="fa fa-long-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="hc-faq-cont collum-shadow column-hoverv1 col-sm-6"
                        >
                          <div class="hc-faq-cont-col">
                            <h1 class="wow fadeIn">
                              Do I have to pay a setup fee?
                            </h1>
                            <div class="wow fadeIn">
                              <p>
                                There is no setup fee for any of our services.
                                <br />
                                <br />
                              </p>
                            </div>
                            <div class="hc-btn-read-more-red wow fadeIn">
                              <a href="/faq" title>
                                Read more
                                <i class="fa fa-long-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          class="hc-faq-cont collum-shadow column-hoverv1 col-sm-6"
                        >
                          <div class="hc-faq-cont-col">
                            <h1 class="wow fadeIn">
                              Can any under 18 years old client
                              <br />obtain this service?
                            </h1>
                            <div class="wow fadeIn">
                              <p>
                                Directly it is not possible, but a guardian
                                <br />can represent the client and obtain the
                                service.
                              </p>
                            </div>
                            <div class="hc-btn-read-more-red wow fadeIn">
                              <a href="/faq" title>
                                Read more
                                <i class="fa fa-long-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class>
                        <div class="hc-btn-read-more-bk-red wow fadeIn">
                          <a href="/faq" title>VIEW MORE QUESTIONS</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PHASE 10 -->
            <div class="clearfix"></div>
            <div class="hc-home-hosting-wp-support">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <h1 class="wow fadeIn no-margin hc-h1">
                      Highly Committed Service
                    </h1>
                    <div class="wow fadeIn margin-top-bottom-30">
                      <p class="hc-p">
                        Our well trained and qualified staff works round the
                        clock.
                        <br />Their commitment makes sure that each and every
                        customer <br />is offered with the best service on
                        content removal, monitoring <br />and management
                        together with optional services.
                      </p>
                    </div>
                    <div class="spacer_10"></div>
                    <div class="clearfix"></div>
                    <div class="btn-start-chart">
                      <a
                        class="wow fadeIn"
                        href="javascript:void(0)"
                        title
                        id="chat-start"
                        >START CHAT</a
                      >
                    </div>
                  </div>
                  <div class="text-center col-sm-12 col-md-6">
                    <div class="wow fadeIn">
                      <img
                        class="aligncenter size-medium"
                        src="/static/assets/images/highly_committed_service.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/
/* eslint-disable */
setTimeout(function () {
  //moving slider
  var scrollSpeed = 60; // Speed in milliseconds
  var step = 1; // How many pixels to move per step
  var current = 0; // The current pixel row
  var imageWidth = 3473; // Background image width
  var headerWidth = 1170; // How wide the header is.

  //The pixel row where to start a new loop
  var restartPosition = -(imageWidth - headerWidth);

  function scrollBg() {
    //Go to next pixel row.
    current += step;

    //If at the end of the image, then go to the top.
    if (current == restartPosition) {
      current = 0;
    }

    //Set the CSS of the header.
    // jQuery(".slider-moving").css("background-position", current + "px 0");
  }

  // setInterval(scrollBg, scrollSpeed);

  jQuery(".mt_typed_text_5b48675d69375").typed({
    strings: [
      "your content",
      "your data",
      "your brand",
      "your intellectual property",
      "your reputation",
      "your privacy",
    ],
    typeSpeed: 0.1,
    backDelay: 3000,
    loop: true,
  });
});

export default {
  name: "main",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  /* min-height: 500px; */
  overflow: hidden;
  padding: 0;
  margin: 20px 0;
}
.vimeo-wrapper-test {
  display: block;
  /* position: absolute; */
  top: 0%;
  left: calc((100vw - 60vw) / 2);
  margin: 0 auto;
  width: calc(60vw);
  height: calc(60vw / 2);
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.video-section {
  padding: 100px 0;
}
.video-section .video-img {
  position: relative;
}
.video-section .video-img .video-icon {
  position: absolute;
  top: calc(calc(100% - 120px) / 2);
  left: calc(calc(100% - 120px) / 2);
  background-color: #ddd;
  color: #6b79e2;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border-radius: 100%;
  font-size: 40px;
  animation: bounceIn 5s infinite;
  transition: 0.2s ease-in-out;
}
.video-section .video-img .video-icon:hover {
  background-color: #6b79e2;
  color: #fff;
  cursor: pointer;
  animation: none;
}
.video-section .video-img .fa-play {
}
.video-section .video-img .fa-play {
}

@media (max-width: 575.98px) {
  .video-section .video-img .video-icon {
    top: calc(calc(100% - 60px) / 2);
    left: calc(calc(100% - 60px) / 2);
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue